module.exports = __webpack_public_path__ + "static/media/Coate-and-Cha.8d1bdb44.jpg";